import Modal2 from 'components/commons/modal/Modal2';
import { linkToOptionalAssetRegistration } from 'pages/OptionalAssetRegistration';
import { Link } from 'react-router-dom';
import React from 'react';

export const WhatIsTargetAchievementSupportModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-base">
            資産目標サポートとは
          </div>
          <img
            src="/static/images/advisor/ai_advisor_firstview_new.svg"
            alt="資産目標サポートとは"
            className="mt-4"
          />
          <div className="text-sm mt-4">
            資産目標サポートでは、資産目標を達成するための進捗確認やおすすめの運用方法についてご案内します。
            <br />
            口座連携すると、資産目標に対する進捗が分かりやすくなります。
          </div>
          <div className="flex flex-row text-active mt-6 mb-2 ml-auto">
            <div className="ml-auto flex flex-row">
              <Link className="" to="/securityaccounts">
                <div className="flex flex-row text-xs items-center">
                  <div className="icon-right"></div>
                  <div className="">口座・資産情報連携</div>
                </div>
              </Link>
              <Link
                className=""
                to={linkToOptionalAssetRegistration('advisor')}>
                <div className="flex flex-row ml-4 text-xs items-center">
                  <div className="icon-right"></div>
                  <div className="">資産を直接入力</div>
                </div>
              </Link>
            </div>
          </div>
          <button
            className="mt-2 p-2 font-bold text-bluegray-550 justify-center w-full text-base"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
